import type { UiStrings } from '../types'

const ko: UiStrings = {
  brand: '홀카드 EX',
  docTitleSuffix: '과정 기록',
  tagline: '자리·홀카드·보드·라인 과정 기록 — 공유용 카드',
  metaDescription: '홀카드 EX — 모바일 친화 포커 과정 기록. 자리·홀카드·보드·스트리트 액션을 공유용 카드로.',
  stepsAria: '단계',
  prev: '이전',
  undo: '되돌리기',
  next: '다음',
  nextSummary: '요약 보기',
  privacyLink: '개인정보·광고 정책',
  privacyTitle: '개인정보·광고 정책',
  privacyHint:
    'AdSense 심사 대비 초안입니다. 실제 서비스 전 내용을 검토·업데이트하세요.',
  privacyBack: '앱으로 돌아가기',
  privacyCollectTitle: '1. 수집하는 정보',
  privacyCollectBody:
    '현재 홀카드 EX는 핸드 리뷰 초안을 브라우저에서만 조립합니다. 계정 로그인 없이 동작하며, 입력한 핸드 정보는 서버로 전송하지 않습니다. 초안은 이 기기 탭의 sessionStorage에만 잠시 보관될 수 있습니다(추후 기능 추가 시 본 정책을 갱신합니다).',
  privacyAdsTitle: '2. 쿠키·광고',
  privacyAdsBody:
    'Google AdSense 등 제3자 광고 네트워크가 사용될 수 있습니다. 광고 사업자는 쿠키·기기 식별자를 사용해 관심사 기반 광고를 표시할 수 있습니다. 사용자는 브라우저 설정 또는 Google 광고 설정에서 맞춤 광고를 제어할 수 있습니다.',
  privacyContactTitle: '3. 문의',
  privacyContactBody:
    '정책 문의는 holdcard-ex.com GitHub 이슈로. 운영자 이메일: 프로젝트 설정의 TODO_OPERATOR_EMAIL.',
  langAria: '언어',
  langCompactAria: '언어 (짧게)',
  koPathLink: '한국어',
  koPathLinkAria: '한국어 버전 (/ko)',
  enPathLink: 'English',
  enPathLinkAria: '영어 버전 (/)',

  setupTitle: '테이블',
  setupHint: '인원·스택·블라인드 — 이어서 시트 → 핸드 → 라인',
  players: '인원',
  playersUnit: (n) => `${n}명`,
  sb: 'SB',
  bb: 'BB',
  ante: '앤티 (선택)',
  anteHint: '블라인드와 같은 단위',
  effectiveStack: '유효 스택 (BB, 선택)',
  potBb: '팟 (BB, 선택)',
  metaOptionalHint: '앤티·유효 스택·팟은 비워 두면 요약에 표시되지 않습니다',
  setupDetailsToggle: '인원·스택·앤티·유효·팟·칩',
  setupBasicsHint: '기본(6max·100bb)이면 다음 또는 건너뛰기',
  setupMetaSetChip: '스택·앤티·eff·팟 설정됨',
  stackUnit: '스택 단위',
  stackUnitBb: 'BB',
  stackUnitChips: '칩',
  stackChips: '스택 (칩)',
  stackBb: '스택 (BB)',
  stackChipsUnit: '칩',

  positionTitle: '시트',
  seatQuestion: '어디 앉았어요?',
  settingsBack: '돌아가기',
  settingsSegAria: '테이블 설정 (인원 · 블라인드 · 스택)',
  lineSeatEditAria: '시트 고치기',
  lineHoleEditAria: '홀카드 고치기',
  positionHint: (count, hint) =>
    `${count}맥스 기준 자리${hint ? ` · ${hint}` : ''}`,

  tableVizAria: (n) => `${n}인 테이블 시트`,
  tableVizHeroBadge: '나',
  tableVizHeroSeatAria: (seat) => `${seat}(나)`,
  tableVizDealer: 'D',
  tableVizDealerTitle: '딜러 버튼',
  tableVizTapHint: '테이블에서 내 시트를 탭하세요',
  tableVizListFallback: '시트 목록 · 코드',
  tableVizBlindsAria: (v) => `블라인드 ${v}`,
  tableVizPotPlaceholder: '팟',
  tableVizPotValue: (v) => `팟 ${v}`,
  tableVizPotAria: (v) => `팟 ${v}`,
  tableVizStackAria: (v) => `스택 ${v}`,
  tableVizEmptyMark: '—',
  tableVizEffHint: (v) => `유효 ${v}bb`,
  tableVizEffTitle: '유효 스택 (테이블 공통 · 좌석별 아님)',
  tableVizStepDown: '감소',
  tableVizStepUp: '증가',
  tableVizEditDone: '완료',
  tableVizInfoHint: '테이블에서 블라인드·팟·스택을 탭해 수정',
  seatAbbrevHint: '자리 약어예요. 탭하면 풀네임이 나와요.',

  cardsTitle: '핸드',
  cardsHint: '내 카드부터 · 상대는 「상대도 입력」에서 · 슬롯·무늬·숫자 · 중복 불가',
  heroHolesGuide: (seat) => `${seat} 홀카드 2장을 고르세요.`,
  cardSlot1: '카드1',
  cardSlot2: '카드2',
  cardSlotSelect: '선택',
  seatsLabel: '좌석',
  knownHolesOptional: '상대 홀카드는 선택 사항입니다 (쇼다운·리뷰용 · 비워도 OK)',
  holesBySeat: '홀카드 · 좌석 선택',
  seatVillain: (pos) => `상대 ${pos}`,
  seatFilled: '입력됨',
  holesModeHeroOnly: '내 카드만',
  holesModeWithVillains: '상대도 입력',
  holesModeAria: '홀카드 입력 모드',
  villainNudgeToast: '상대 카드를 알면 BB 등을 탭하세요',
  heroCardsDoneCta: '라인으로',
  heroCardsAddVillainsCta: '상대도 입력',
  suitPickerLabel: '무늬',
  rankPickerLabel: '숫자',

  boardTitle: '보드',
  boardHint: '도착했을 때 입력 — 프리플롭만이라면 건너뛰기',
  flop: '플롭',
  turn: '턴',
  river: '리버',
  flopSlot: (i) => `F${i}`,

  actionsTitle: '라인',
  actionsHint: '스트리트별 액션 라인 — 폴드/체크/콜/벳/레이즈/올인',
  actorQuick: '액터 빠른 선택',
  actor: '액터',
  actorPlaceholder: '이름 입력',
  actorCustomToggle: '직접 입력',
  actorRequired: '액터를 입력하거나 선택해 주세요',
  action: '액션',
  sizeLabel: '사이즈',
  sizePlaceholder: '예: 2.5bb',
  sizeRequired: '벳/레이즈 사이즈를 입력해 주세요',
  sizeCustomToggle: '직접 입력',
  sizeOpenApprox: '레이즈',
  sizePotApprox: '팟 사이즈',
  sizeOverbetApprox: '오버벳',
  sizeJamApprox: '쇼트 / jam',
  sizeUnitBb: 'bb',
  sizeUnitPct: 'pot',
  snapHint: '눈금에 스냅 · ±로 한 칸',
  favoritesLabel: '자주 씀',
  morePresets: '더 많은 프리셋',
  presetsSizeLabel: '프리셋 · 사이즈',
  potSizeHintUnset: '팟(BB)을 설정하면 팟 사이즈가 bb로 보여요',
  clearOptional: '없음',
  betRaiseHint: '벳: 아직 공격이 없을 때 · 레이즈: 이미 벳/레이즈가 있을 때',
  allinSizeHint: '올인 사이즈 선택 (선택 사항)',
  sizeActionHint: (potBit) =>
    potBit
      ? `벳=선공 · 레이즈=대응 · ${potBit}`
      : '벳=선공 · 레이즈=대응',
  addAction: (street) => `${street} 액션 추가`,
  updateAction: '수정 적용',
  editAction: '수정',
  cancelEdit: '수정 취소',
  noStreetActions: (street) => `${street} 기록이 없습니다.`,
  delete: '삭제',
  moveUp: '위로',
  moveDown: '아래로',
  allActionsHint: (n) => `전체 ${n}개 액션 · 다른 스트리트 탭에서 확인`,
  heroChip: (pos) => pos,
  seatOrderHu: '헤즈업: BTN이 SB 역할 · 순서 BTN/SB → BB',
  seatOrder: (order) => `자리 순서: ${order}`,
  positionHintHuBtn: '헤즈업 버튼 (SB)',
  keepActorHint: '스트리트 전환 시 액터를 유지합니다 (타입·사이즈만 초기화)',
  potQuickPrompt: '팟(BB) 빠른 입력 — 탭하면 힌트가 갱신됩니다',
  potQuickClear: '팟 지우기',
  quickLinesLabel: '빠른 라인',
  quickLinesHint: '자주 쓰는 템플릿 · 탭하면 액션이 추가됩니다',
  macroOpenThenCall: '레이즈 후 콜',
  macroFoldToHero: (seat) => `${seat}까지 폴드`,
  macroCbet33: 'C-bet ⅓ pot',
  quickLinesSwitchStreet: '스트리트를 바꾸면 매크로가 표시됩니다',
  macroOpenExists: '이미 레이즈가 기록되어 있어요',
  macroAlreadyLogged: '레이즈와 콜이 이미 기록되어 있어요',
  macroFoldToHeroNone: (seat) => `앞에 폴드할 시트가 없어요 (${seat} 먼저 행동)`,
  macroFoldToHeroBlocked: '이미 앞 액션이 있어요 — 폴드는 직접 추가하세요',
  boardCtaFlop: '플롭 카드 추가',
  boardCtaTurn: '턴 카드 추가',
  boardCtaRiver: '리버 카드 추가',
  quickHand: '빠른 핸드',
  skipToCards: '다음 단계 건너뛰고 카드부터',
  jumpToActions: '라인으로',
  skipBoardPreflop: '보드 건너뛰기 — 프리플롭만',
  boardSlotsToggle: '보드 카드 넣기',
  softStackAria: '지금까지 핸드',
  softStackLine: '라인',
  softStackHoles: '홀',
  softStackBoard: '보드',
  streetTabWithCount: (street, n) => `${street} · ${n}`,
  actionIndexLabel: (n, street) => `액션 ${n} · ${street}`,
  copyLinkTitle: '앱에서 이 핸드를 다시 엽니다',
  suitStickyHint: '무늬 유지 중 · 탭해서 변경',
  suitStickyChip: (s) => `현재 슈트 ${s}`,
  suitMruLabel: '최근',

  summaryHint:
    '아래 과정 카드를 스크린샷하거나 텍스트를 복사·공유하세요',
  summaryHole: '홀카드',
  summaryBoard: '보드',
  summaryActions: '액션',
  timelineProcess: '과정',
  timelineBoard: (cards) => `보드 ${cards}`,
  processMoreSummary: '과정 더 보기',
  linePeekSummary: '지금까지 줄',
  takeawayLabel: '한 줄',
  takeawayPlaceholder: '자리·라인만 — 예: BTN 레이즈 후 BB 콜, 플롭 체크',
  takeawayHint: '과정 한 줄 — 자리·라인만',
  takeawayNudge: '과정 한 줄 (선택)\u00a0· 자리·라인',
  takeawayInLinkFact: '과정 한 줄이 링크에 들어갑니다',
  shareSecondarySummary: '메모·상대 (선택)',
  shareSecondaryInvite: '과정 한 줄 남기기 (선택)',
  shareMoreSummary: '다른 공유',
  lineDraftSummary: '액터·사이즈 입력',
  explainModeLabel: '설명',
  explainModeAria: '설명 모드 — 학습용 힌트 표시',
  reviewScopeLabel: '여기까지 리뷰',
  reviewScopePreflop: '프리플롭',
  reviewScopeFlop: '플롭',
  reviewScopeRiver: '리버',
  reviewScopeAria: '리뷰 범위 — 이후 스트리트는 접힘(삭제 아님)',
  shareProcessHu: '헤즈업',
  shareProcessMultiway: '멀티웨이',
  shareReviewedLabel: '리뷰한 시각',
  summaryCopyLabel: '채팅에 붙여넣기 — 읽기 쉬운 요약 + Pro',
  summaryProLabel: 'Pro notation',
  emptyDash: '—',
  copyBoth: '채팅에 공유',
  copyHuman: '읽기 쉽게',
  copyPro: 'Pro 표기',
  copied: '복사됨 ✓',
  copiedToast: '핸드 카드 요약이 복사되었습니다',
  screenshotHint: '캡처 = 깔끔한 카드 샷 · 링크 = 핸드 다시 열기',
  captureMode: '캡처',
  captureExit: '캡처 종료',
  saveShareImage: '이미지 저장',
  shareImage: '이미지 공유',
  imageSaved: '저장됨 ✓',
  imageShared: '공유됨 ✓',
  imageSavedToast: '핸드 카드 이미지 저장됨',
  imageSharedToast: '이미지 공유됨',
  imageFailedToast: '이미지를 만들지 못했습니다',
  shareText: '텍스트 공유',
  shared: '공유됨 ✓',
  copyLink: '링크 복사',
  linkCopiedToast: '핸드 링크가 복사되었습니다',
  linkWithoutKnownHolesToast:
    '링크가 길어 빌런 홀카드는 빼고 복사했습니다',
  linkTooLongToast: '핸드가 길어 링크를 만들 수 없습니다',
  sharedToast: '공유되었습니다',
  shareFailedToast: '공유에 실패했습니다',
  newHand: '새 핸드 작성',
  receivedQuietRerecordCta: '이 과정으로 나도 기록',
  draftRestoredHint: '초안을 복원했어요 — 이어갈까요, 새로 시작할까요?',
  draftContinue: '이어가기',
  actorFoldedHint: '이미 폴드',
  summaryHeading: '[홀카드 EX 핸드 요약]',
  summaryPlayers: (n) => `인원: ${n}명`,
  summaryBlinds: (b) => `블라인드: ${b}`,
  summaryHero: (p) => `자리: ${p}`,
  summaryStack: (s) => `스택: ${s}`,
  summaryEff: (e) => `유효 스택: ${e} BB`,
  summaryPot: (p) => `팟: ${p} BB`,
  summaryHoleLine: (h) => `홀카드: ${h}`,
  summaryHolesHeader: '홀카드:',
  summaryKnownHoleLine: (label, cards) => `· ${label}: ${cards}`,
  summaryBoardLine: (b) => `보드: ${b}`,
  summaryActionsHeader: '── 액션 ──',
  summaryFooter: '— 홀카드 EX로 작성',
  summaryProHeader: '── Pro notation ──',
  tableLine: (n, blinds) => `${n}명 · ${blinds}`,

  errorBlinds: '블라인드가 올바르지 않습니다. BB는 0보다 커야 하고, SB는 0 이상이며 BB 이하여야 합니다.',
  hintFlopPartial: '플롭은 보통 3장입니다',
  hintNoActions: '액션 없이도 괜찮아요 — 「기록 마치기」는 여기까지 기록을 공유해요',
  missingFlopBoard: '플롭 액션이 있는데 보드 플롭 카드가 없어요',
  missingTurnBoard: '턴 액션이 있는데 턴 카드가 없어요',
  missingRiverBoard: '리버 액션이 있는데 리버 카드가 없어요',
  boardActionsMismatch: '보드 카드가 비어 있는 스트리트에 액션이 있어요',
  boardNeedFlop: '플롭 보드가 비어 있어요 — 카드 추가를 권장합니다',
  boardNeedFlopPartial: '플롭 카드를 마저 입력하세요',
  boardNeedTurn: '턴 카드가 비어 있어요 — 카드 추가를 권장합니다',
  boardNeedRiver: '리버 카드가 비어 있어요 — 카드 추가를 권장합니다',

  softGateTitle: '아직 비어 있는 항목이 있어요',
  softGateBody: '홀카드가 아직 비어 있어요. 홀카드를 추가해 과정을 남기거나, 그래도 계속할 수 있어요.',
  softGateFix: "홀카드 추가",
  softGateForceConfirm: "미완성인데도 공유할까요?",
  softGateMissingHoles: (seat) => `${seat} 홀카드 2장`,
  softGateMissingActions: "최소 한 번의 액션",
  softGateBodyLead: "아직 필요한 것:",
  incompleteBadge: "미완성",
  softGateContinue: '그래도 요약 보기',
  softGateShare: '그래도 공유',
  softGateCopy: '그래도 복사',
  softGateCancel: '돌아가기',
  pickerDisabled: '선택할 슬롯이 없습니다',

  step: {
    setup: '테이블',
    position: '시트',
    cards: '핸드',
    board: '보드',
    actions: '라인',
    summary: '공유',
  },
  street: {
    preflop: '프리플롭',
    flop: '플롭',
    turn: '턴',
    river: '리버',
  },
  actionType: {
    fold: '폴드',
    check: '체크',
    call: '콜',
    bet: '벳',
    raise: '레이즈',
    allin: '올인',
  },
  suit: {
    s: '스페이드',
    h: '하트',
    d: '다이아',
    c: '클럽',
  },
  positionHintMap: {
    UTG: '언더 더 건',
    'UTG+1': 'UTG 다음',
    MP: '미들 포지션',
    'MP+1': '미들+1',
    HJ: '하이잭',
    CO: '컷오프',
    BTN: '버튼(딜러)',
    SB: '스몰 블라인드',
    BB: '빅 블라인드',
  },

  progressAria: (current, total, label) =>
    `${total}단계 중 ${current}단계: ${label}`,
  adArea: '광고 영역',
  adTop: '상단 광고 영역',
  adBottom: '하단 광고 영역',
  adPlaceholderHint: 'AdSense ID 미설정 — 배포 전 플레이스홀더',
  // Softwise M10b: memory-order input
  endHere: "여기서 끝",
  finishRecord: "기록 마치기",
  reviewAnte: (v) => `앤티 ${v}`,
  reviewEffStack: (v) => `유효 ${v}`,
  reviewBreakdownAria: '스트리트별 기록',
  reviewPlayers: (n) => `${n}명`,
  // vocab-tags:start — screen-only poker vocabulary (review breakdown)
  reviewVocab: {
    trips: '트립스',
    paired: '페어드',
    monotone: '모노톤',
    twoTone: '투톤',
    rainbow: '레인보우',
    limp: '림프',
    open: '오픈',
    threeBet: '3벳',
    fourBet: '4벳',
    fiveBet: '5벳',
    squeeze: '스퀴즈',
    coldCall: '콜드콜',
    checkRaise: '체크레이즈',
    cBet: 'c벳',
    donkBet: '동크벳',
    probeBet: '프로브',
  },
  shareSavedMark: '저장됨',
  // vocab-tags:end
  flowAskFlop: "플롭 3장",
  flowAskTurn: "턴 1장",
  flowAskRiver: "리버 1장",
  flowWhoActs: "차례",
  flowSizeCustom: "직접",
  flowSizeConfirm: "확인",
  flowSizeLabel: "크기 (bb)",
  flowDone: "라인 기록 완료",
  flowRewind: "여기부터 다시",
  flowRewindCancel: "취소",
  flowSeatUnrecorded: "기록 안 함",
  flowSeatNotInvolved: "참여 안 함",
  flowMemoryCut: "이 거리부터 기억 안 남",
  lineStripAria: "지금까지 기록한 라인",
  // Soft G: optional ending record (L1.5) — seat-subject, press-only, Quiet
  endingSummary: '결말 (선택)',
  endingShownLabel: '쇼다운에서 보여준 카드',
  endingPotLabel: '팟',
  endingCardsInput: '카드 입력',
  endingMuck: '안 보여줌(머크)',
  endingUnknown: '모름',
  endingPotTo: (seat) => `${seat} 팟 가져감`,
  endingSplit: '나눔',
  endingLineLabel: '결말',
  endingShownCards: (seat, cards) => `${seat} ${cards} 보여줌`,
  endingShownMuck: (seat) => `${seat} 안 보여줌(머크)`,
  endingShownUnknown: (seat) => `${seat} 카드 모름`,
  endingPotSplit: '팟 나눔',
  endingPotUnknown: '팟 모름',
  linkWithoutEndingToast: '링크가 길어 결말은 빼고 복사했습니다',
  linkWithoutTakeawayToast: '링크가 길어 과정 한 줄은 빼고 복사했습니다',
  endingShownAria: (seat) => `${seat} 쇼다운 카드`,
}

export default ko
